import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {VetClinicStartContextData} from "../../models/vet-clinic-start-context-data.model";
import {User} from "../../models/user.model";
import {CommonUtils} from "../../utils/common";
import {UserService} from "../../providers/user.service";
import {ToastController} from "@ionic/angular";
import {ClientsService} from "../../providers/clients.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {mobilePhoneNumberValidator, mustMatch} from "../../utils/form-validators";
import {VetClinic} from "../../models/vet-clinic.model";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-import-clinic',
  templateUrl: './import-clinic.component.html',
  styleUrls: ['./import-clinic.component.scss'],
})
export class ImportClinicComponent implements OnInit, OnDestroy {

  @Input() csrfToken: string;

  private userGroup: FormGroup;
  private vetClinicStartContextSub: Subscription;
  private vetClinicStartContext: VetClinicStartContextData;
  private hasUnsavedChanges = false;
  private sendEmail: boolean;
  private user: User;
  private isGeneralAdmin: boolean;

  @Output() importClinicEmitter = new EventEmitter<VetClinic>();
  @Output() userAddCanceledEmitter = new EventEmitter<Boolean>();
  @Input() vetCodeId: string;

  constructor(
    public commonUtils : CommonUtils,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastController: ToastController,
    private clientService: ClientsService,
    private vetClinicService: VetClinicService,
    private appStateService: AppStateService
  ) {
  }

  ngOnInit() {
    this.isGeneralAdmin = false;
    this.userService.getUser().subscribe(u => {
      if (u !== null) {
        this.user = this.commonUtils.bestTypedCopyEver<User>(new User(), u);
      }
    });

    this.vetClinicStartContextSub = this.vetClinicService.getVetClinicStartContextData().subscribe((vetClinicStartContext) => {
      this.vetClinicStartContext = vetClinicStartContext;
    });
    this.sendEmail = false;
    this.userGroup = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      mobilePhone: ['', [Validators.required, mobilePhoneNumberValidator]],
      email: ['', Validators.email]
    },);
  }


  onAdd() {
    this.appStateService.updateIsBusySubject(true);
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz dodać nowego użytkownika i importować lecznicę?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let userAdded: User = this.commonUtils.formGroupValuesToObject<User>(new User(), this.userGroup);

      userAdded.roles = 'admin'
      userAdded.vetcodeId = this.vetCodeId

        this.userService.importClinicAndAddUser(userAdded).subscribe(clinic => {
          this.appStateService.updateIsBusySubject(false);
          if (clinic) {
            this.commonUtils.presentInfoToast("Klinika zaimportowana poprawnie").then(res => {
              this.importClinicEmitter.emit(clinic);
            });
          } else {
            this.commonUtils.presentAlertToast("Wystąpił błąd podczas importowania kliniki");
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false);
          let errorMsg = error.error.errors.main;
          if (errorMsg === 'USER_NOT_FOUND') {
            this.commonUtils.presentAlertToast('Brak zalogowanego użytkownika');
          }
          if (errorMsg === 'USER_UNAUTHORIZED') {
            this.commonUtils.presentAlertToast('Nie masz uprawnień');
          }
          if (errorMsg === 'BAD_VCLIENT') {
            this.commonUtils.presentAlertToast('Klient nie isnieje');
          }
          if (errorMsg === 'EMAIL_ALREADY_EXIST') {
            this.commonUtils.presentAlertToast('Użytkownik o podanym adresie email istnieje');
          }
          if (errorMsg === 'PHONE_ALREADY_EXIST') {
            this.commonUtils.presentAlertToast('Użytkownik o podanym nr. telefonu istnieje');
          }
          if (errorMsg === 'EXCEPTION_DURING_ADDING') {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas dodawania');
          }
          if (errorMsg === 'CLINIC_IMPORT_FAILED') {
            this.commonUtils.presentAlertToast(`Wystąpił błąd importu`);
          }
          if (errorMsg === 'NULL_VETCODE') {
            this.commonUtils.presentAlertToast(`Pusty VetCode`);
          }
          if (errorMsg === 'VET_CLINIC_EXIST') {
            this.commonUtils.presentAlertToast(`Lecznica o podanym VetCode istnieje`);
          }
          if (errorMsg === 'CLIENT_EXIST') {
            this.commonUtils.presentAlertToast(`Klient lecznicy o podanym VetCode istnieje`);
          }
        });
    }, () => {
    });
  }

  onCancelAdd() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z importu kliniki oraz dodania użytkownika?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.userAddCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.userAddCanceledEmitter.emit(true);
    }
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  isFormInvalid(form: FormGroup, validationType: string) {
    return this.commonUtils.isFormInvalid(form, validationType);
  }

  ngOnDestroy(): void {
    if (this.vetClinicStartContextSub) this.vetClinicStartContextSub.unsubscribe();
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
    }
  }
}
